import { Navigate } from 'react-router-dom';
import { useRouteWithPermission } from '@/hooks/useRouteWithPermission';

/**
 * Sends the viewer to the first page they may open, for routes where a
 * "no access" screen would only be a dead end (e.g. an old bookmark).
 */
export function RedirectToDefaultRoute() {
  const to = useRouteWithPermission();
  return <Navigate to={to} replace />;
}
